import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryParapluie = customSolarIconWrapper(<g transform="translate(60 10)">
	<path d="M5.00098 9.20117C12.3343 22.2012 23.1676 26.5678 37.501 22.3012C44.8343 35.3012 55.6343 39.6678 69.901 35.4012C77.2343 48.4012 88.0676 52.7678 102.401 48.5012C109.734 61.5012 120.534 65.8678 134.801 61.6012" stroke="#202020" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M5.00098 9.20124C59.801 -1.79876 103.068 15.6679 134.801 61.6012" stroke="#202020" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M77.2012 13.7012L80.9012 4.50122" stroke="#202020" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M60.2012 59.5012L69.9012 35.4012" stroke="#202020" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryParapluie;
